export default __webpack_public_path__ + "static/media/planimages_116.7db3cf7d.png";